import { render, staticRenderFns } from "./AdvertisersCheckPage.vue?vue&type=template&id=36f41490&scoped=true&"
import script from "./AdvertisersCheckPage.vue?vue&type=script&lang=js&"
export * from "./AdvertisersCheckPage.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisersCheckPage.vue?vue&type=style&index=0&id=36f41490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f41490",
  null
  
)

export default component.exports